export default "__VITE_ASSET__DjpO6IbN__"